import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "down",
  "use": "down-usage",
  "viewBox": "0 0 12 8",
  "content": "<symbol viewBox=\"0 0 12 8\" id=\"down\"><path fill-rule=\"evenodd\" d=\"M6 5.602L1.2.8 0 2l6 6.002L12 2 10.8.8 6 5.602z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/chevron/down.svg
// module id = ./src/assets/icons/chevron/down.svg
// module chunks = 2